module.exports = __webpack_public_path__ + "img/selected3-min.ec3a8bb6.png";